<template>
  <div>
    <a-modal v-model="getValue" :width="comparisonPremiums.length === 3 ? 1000:800">
      <div style="display:flex; flex-direction: row; justify-content: start;">
        <a-checkbox v-model="showOnlyWithDifference" style="margin-right: 1em;">
          Alleen regels met verschil weergeven
        </a-checkbox>
        <a-input v-model="search" placeholder="Zoeken..." style="width: 150px;">
        </a-input>
      </div>
      <a-table :columns="getColumns" :data-source="getRules" :row-key="getUniqueKey">
        <div v-for="(i) in comparisonPremiums.length" :slot="`customTitle${i}`"
             style="display: flex; flex-direction: column; align-items: center;">
          <lazy-component>
            <object :data="`/web_api/v1/compare/car/images/${comparisonPremiums[i - 1].Productid}`"
                    type="image/png"
                    style="width:100px">
              Geen afbeelding beschikbaar
            </object>
          </lazy-component>
          <small style="margin-top: 1em;">
            {{ comparisonPremiums[i - 1].Productnaam }}
          </small>
        </div>
      </a-table>
      <template #footer>
        <a-button @click="getValue = false">Sluiten</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'CompareCarPremiumModal',
  props: {
    rules: {
      type: Array,
      default: () => []
    },
    value: {
      type: Boolean,
      required: true
    },
    comparisonPremiums: {
      type: Array,
      required: Array
    }
  },
  data() {
    return {
      showOnlyWithDifference: false,
      search: '',
    }
  },
  methods: {
    applySearch(rules) {
      return rules.filter(rule => {
        if (rule.Tekst.includes(this.search)) {
          return true;
        }

        for (let item of rule.Polisvergelijkingsitem) {
          if (item.Tekst.includes(this.search)) {
            return true;
          }
        }

        return false;
      })
    },
    getUniqueKey(record) {
      return record.Tekst + Math.random();
    }
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    },
    getRules() {
      let rules = this.rules;

      rules = rules.filter(rule => rule.Heeftoordeel === 'True' && (!this.showOnlyWithDifference || rule.HeeftVerschillen === 'True'));

      return this.applySearch(rules);
    },
    comparisonPremiumsAmount() {
      return this.comparisonPremiums.length;
    },
    getColumns() {
      let columns = [
        {
          title: 'Beschrijving',
          dataIndex: 'Tekst'
        },
        {
          dataIndex: 'Polisvergelijkingsitem.0.Tekst',
          slots: {title: 'customTitle1'}
        },
        {
          dataIndex: 'Polisvergelijkingsitem.1.Tekst',
          slots: {title: 'customTitle2'}
        }
      ];

      if (this.comparisonPremiumsAmount === 3) {
        columns.push({
          dataIndex: 'Polisvergelijkingsitem.2.Tekst',
          slots: {title: 'customTitle3'}

        })
      }

      return columns;
    }
  }
}
</script>

<style scoped>

</style>
